import { render } from "./CContact.vue?vue&type=template&id=11a62b0c"
import script from "./CContact.vue?vue&type=script&lang=js"
export * from "./CContact.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__